import React from 'react';
import { string, shape } from 'prop-types';
import { ContentWrapper } from './SocialIcons.styles';
import { renderSocialMediaIcons } from '../../Utils/renderSocialMediaIcons';
export const SocialIcons = _ref => {
  let {
    type,
    colours,
    hoverColours
  } = _ref;
  return /*#__PURE__*/React.createElement(ContentWrapper, {
    "aria-label": type,
    colours: colours,
    hoverColours: hoverColours
  }, renderSocialMediaIcons(type));
};
SocialIcons.propTypes = {
  type: string.isRequired,
  colours: shape({
    backgroundColour: string.isRequired,
    logoColour: string.isRequired,
    backgroundStrokeColour: string.isRequired
  }).isRequired,
  hoverColours: shape({
    backgroundColour: string.isRequired,
    logoColour: string.isRequired,
    backgroundStrokeColour: string.isRequired
  }).isRequired
};